// extracted by mini-css-extract-plugin
module.exports = {"navigation":"styles_navigation__eNMTt","button":"styles_button__Vr8nf","visible":"styles_visible__GE5yl","disabled":"styles_disabled__gdxID"};